import Vue from 'vue';

Vue.directive('number-only', {
  bind(el, binding, vnode) {
    const input = el.querySelector('input');
    const decimalPlaces = binding.value || 0; // 默认最多保留0位小数，即整数

    input.addEventListener('input', function (event) {
      const value = event.target.value;

      // 如果小数保留位数为0，则不允许输入小数点
      const regex = decimalPlaces === 0 ? /^\d*$/ : new RegExp(`^\\d*(\\.\\d{0,${decimalPlaces}})?$`);

      if (!regex.test(value)) {
        // 如果输入不符合要求，则回退到上一次的有效值
        event.target.value = vnode.context[binding.expression] || '';
      } else {
        // 更新绑定的值
        vnode.context[binding.expression] = value;
      }
    });

    input.addEventListener('blur', function (event) {
      const value = event.target.value;
      if (value) {
        let formattedValue = value.replace(/\.$/, ''); // 去除末尾的小数点
        if (decimalPlaces > 0) {
          // 如果允许小数
          const parts = formattedValue.split('.');
          if (parts.length === 2) {
            // 如果包含小数部分
            const integerPart = parts[0];
            let decimalPart = parts[1].substring(0, decimalPlaces); // 限制小数位数
            decimalPart = decimalPart.replace(/0+$/, ''); // 去除小数部分末尾的0
            formattedValue = decimalPart ? `${integerPart}.${decimalPart}` : integerPart;
          }
        } else {
          // 如果不允许小数，直接取整数部分
          formattedValue = formattedValue.split('.')[0];
        }
        event.target.value = formattedValue;
        vnode.context[binding.expression] = formattedValue;
      }
    });
  },
});

Vue.directive('table-scroll', {
  bind(el, binding) {
    let scrollTopAccumulator = 0;
    const tableWrapper = el.querySelector('.el-table__body-wrapper');
    if (!tableWrapper) return;

    // 滚动速度控制（默认为1）
    const speed = binding.value?.speed || 0.3;
    // 是否悬停暂停（默认true）
    const hoverStop = binding.value?.hoverStop !== false;
    // 滚动方向（默认垂直）
    const direction = binding.value?.direction || 'vertical';
    
    let isScrolling = false;
    let scrollInterval = null;
    let isHovering = false;

    // 水平滚动函数
    const scrollHorizontal = () => {
      if (isHovering && hoverStop) return;
      
      tableWrapper.scrollLeft += speed;
      
      if (tableWrapper.scrollLeft >= tableWrapper.scrollWidth - tableWrapper.clientWidth) {
        tableWrapper.scrollLeft = 0;
      }
    };

    // 垂直滚动函数
    const scrollVertical = () => {
      if (isHovering && hoverStop) return;
      
      // 累积小数值直到达到或超过1px
      scrollTopAccumulator = (scrollTopAccumulator || 0) + speed;
      if (scrollTopAccumulator >= 1) {
        tableWrapper.scrollTop += Math.floor(scrollTopAccumulator);
        scrollTopAccumulator -= Math.floor(scrollTopAccumulator);
      }
      
      if (tableWrapper.scrollTop >= tableWrapper.scrollHeight - tableWrapper.clientHeight) {
        tableWrapper.scrollTop = 0;
      }
    };

    // 开始滚动
    const startScroll = () => {
      if (isScrolling) return;
      isScrolling = true;
      
      scrollInterval = setInterval(() => {
        if (direction === 'horizontal') {
          scrollHorizontal();
        } else {
          scrollVertical();
        }
      }, 16); // 约60fps
    };

    // 停止滚动
    const stopScroll = () => {
      isScrolling = false;
      clearInterval(scrollInterval);
      scrollInterval = null;
    };

    // 鼠标悬停事件
    if (hoverStop) {
      tableWrapper.addEventListener('mouseenter', () => {
        isHovering = true;
      });
      
      tableWrapper.addEventListener('mouseleave', () => {
        isHovering = false;
      });
    }

    // 初始化滚动
    startScroll();

    // 保存函数引用以便解绑
    el._tableScroll = {
      startScroll,
      stopScroll
    };
  },

  unbind(el) {
    if (el._tableScroll) {
      el._tableScroll.stopScroll();
      delete el._tableScroll;
    }
  }
})